import React from "react";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import CustomTabs from "../../components/CustomComponents/CustomTabs/CustomTabs";
import CustomTab from "../../components/CustomComponents/CustomTab/CustomTab";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import WallofLegends from "../../components/WallofLegends/WallofLegends";
import ContentEngagement from "../../components/ContentEngagement/ContentEngagement";
import DateTime from "../../components/DateTime/DateTime";
import { useStyles } from "../../assets/jss/WallofLegends";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { getUserRBAC, checkAPICallDate } from "../../services/LocalStorageService";
import { RBAC_CODE, EntityAccess, APICache } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function WallofLegendContentEngagementTab(props) {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    // const [getRBAC] = React.useState(getUserRBAC);
    const [getRBAC_CE] = React.useState(getUserRBAC(RBAC_CODE.CE_VIEW, props));
    const [getRBAC_WOL] = React.useState(getUserRBAC(RBAC_CODE.WOL_VIEW, props));
    const defaultValue = props.location.pathname === "/engagement" || props.location.pathname === `/impersonation/${params.impersonationid}/engagement` ? 1 : 0;
    const [value, setValue] = React.useState(defaultValue);
    let url = value === 0 ? APICache.WOL_API : APICache.CONTENT_API;
    const [currentDate] = React.useState(checkAPICallDate(params.impersonationid ? `${url}?impersonationId=${params.impersonationid}` : url));
    const [googleAnalyticsId] = React.useState(process.env.REACT_APP_GOOGLE_TAG_ID);

    // React.useEffect(() => {
    //     if (value === 0) {
    //         setAPICallDate(checkAPICallDate("/insights/wol/stats"));
    //     } else {
    //         setAPICallDate(checkAPICallDate("/campaign/stats"));
    //     }
    // }, [value]);

    const handleTabs = (event, newValue) => {
        newValue === 0
            ? params.impersonationid ? props.history.push(`/impersonation/${params.impersonationid}/walloflegends`) : props.history.push("/walloflegends")
            : params.impersonationid ? props.history.push(`/impersonation/${params.impersonationid}/engagement`) : props.history.push("/engagement");
        setValue(newValue);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }
    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <CustomBox m={3}>{children}</CustomBox>}
            </div>
        );
    }
    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
        className:PropTypes.any
    };

    return (
        <>
            <CustomGrid
                container
                spacing={0}
                justifyContent="space-between"
                alignItems="center"
            >
                <CustomGrid item>
                    <CustomTabs
                        value={value}
                        onChange={handleTabs}
                        aria-label={`${t("WALL_OF_LEGENDS")} && ${t("CONTENT_ENGAGEMENT")}`}
                        indicatorColor="primary"
                        className={classes.tabs}
                    >
                        {getRBAC_WOL &&
                            getRBAC_WOL.isAccessible === EntityAccess.ALLOWED ? (
                            <CustomTab label={t("WALL_OF_LEGENDS")} {...a11yProps(0)} />
                            ) : null}
                            {/* {getRBAC &&
                            getRBAC.find(
                            (item) => item.entityCode === RBAC_CODE.WOL_VIEW && item.isRead === 1
                            ) ? (
                            <CustomTab label="Wall of Legends" {...a11yProps(0)} />
                            ) : null} */}
                            {getRBAC_CE && getRBAC_CE.isAccessible === EntityAccess.ALLOWED ? (
                                <CustomTab label={t("CONTENT_ENGAGEMENT")} {...a11yProps(1)} />
                            ) : null}
                            {/* {getRBAC &&
                            getRBAC.find(
                            (item) => item.entityCode === RBAC_CODE.CE_VIEW && item.isRead === 1
                            ) ? (
                            <CustomTab label="Content Engagement" {...a11yProps(1)} />
                            ) : null} */}
                    </CustomTabs>
                </CustomGrid>
                <CustomGrid item>
                    <CustomTypography
                        className={classes.headerSubNote}
                        component="p"
                        variant="h6"
                    >
                        {t("LAST_UPDATED_ON")}{" "}
                        <DateTime inputDate={currentDate} returnFormat="ddd" />,{" "}
                        <DateTime inputDate={currentDate} returnFormat="DD MMM YYYY" /> |{" "}
                        <DateTime inputDate={currentDate} returnFormat="hh:mm a" />
                    </CustomTypography>
                </CustomGrid>
            </CustomGrid>
            {getRBAC_WOL && getRBAC_WOL.isAccessible === EntityAccess.ALLOWED ? (
                <TabPanel
                    className={classes.tabPanel}
                    key="tab-panel-walloflegend"
                    value={value}
                    index={0}
                >
                    <WallofLegends {...props} />
                </TabPanel>
            ) : null}
            {/* {getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.WOL_VIEW && item.isRead === 1
                ) ? (
                    <TabPanel
                    className={classes.tabPanel}
                    key="tab-panel-walloflegend"
                    value={value}
                    index={0}
                    >
                    <WallofLegends />
                    </TabPanel>
                ) : null} */}
            {/* {getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.CE_VIEW && item.isRead === 1
                ) ? (
                    <TabPanel
                    className={classes.tabPanel}
                    key="tab-panel-contentengagement"
                    value={value}
                    index={1}
                    >
                    <ContentEngagement />
                    </TabPanel>
                ) : null} */}
            {getRBAC_CE && getRBAC_CE.isAccessible === EntityAccess.ALLOWED ? (
                <TabPanel
                    className={classes.tabPanel}
                    key="tab-panel-contentengagement"
                    value={value}
                    index={1}
                >
                    <ContentEngagement {...props} />
                </TabPanel>
            ) : null}

            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
                ></script>
                <script>
                    {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', "${googleAnalyticsId}");
                `}
                </script>
            </Helmet>
        </>
    );
}
